// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import type { KeyboardEventHandler } from 'react';
import cx from 'classnames';
import _ from 'underscore';

import { asNumber } from '@trello/i18n/formatters';
import { intl } from '@trello/i18n/provider';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getKey, Key } from '@trello/keybindings';
import ReactDOM from '@trello/react-dom-wrapper';
import type { RouteId } from '@trello/router';
import { useRouteParams } from '@trello/router';
import { PowerUpTestIds } from '@trello/test-ids';

import { getBoardUrlFromShortLink } from 'app/scripts/controller/urls';
import { categories } from 'app/scripts/data/directory';
import type { Board } from 'app/scripts/models/Board';
import { pluginsChangedSignal } from 'app/scripts/views/internal/plugins/PluginsChangedSignal';
import { ReactRootComponent } from 'app/scripts/views/internal/ReactRootComponent';
import { View } from 'app/scripts/views/internal/View';
import type { DirectoryView } from './DirectoryView';
import { toggleNavigationMenu } from './toggleNavigationMenu';

function DirectorySidebarPlaceholder() {
  return (
    <div>
      <div className="directory-search">
        <div className="directory-navigation-option placeholder" />
      </div>
      <ul>
        <li>
          <div className="directory-navigation-option placeholder" />
        </li>
        <li>
          <div className="directory-navigation-option placeholder" />
        </li>
        <li>
          <div className="directory-navigation-option placeholder" />
        </li>
        <li className="directory-categories">
          <div className="directory-categories-heading placeholder" />
          <ul className="directory-navigation-categories-list">
            {categories.map((categoryKey) => (
              <li key={categoryKey}>
                <div className="directory-navigation-option placeholder" />
              </li>
            ))}
          </ul>
        </li>
      </ul>
    </div>
  );
}

function DirectorySidebar({
  board,
  showCustomCategory,
  clearSearch,
  onSearchKeyUp,
}: {
  board: Board;
  showCustomCategory: boolean;
  clearSearch: () => void;
  onSearchKeyUp: KeyboardEventHandler<HTMLInputElement>;
}) {
  let enabledCount = '';

  const totalEnabled = board.powerUpsCount();

  if (totalEnabled > 0) {
    enabledCount = asNumber(totalEnabled);
  }

  const routeParams = useRouteParams<RouteId.BOARD>();
  const { shortLink, shortName } = routeParams;

  const category = 'category' in routeParams ? routeParams.category : null;
  const section = 'section' in routeParams ? routeParams.section : null;
  const powerUpId = 'powerUpId' in routeParams ? routeParams.powerUpId : null;

  return (
    <div>
      <div className="directory-search">
        <input
          type="text"
          placeholder={intl.formatMessage({
            id: 'templates.directory.search',
            defaultMessage: 'Search',
            description:
              'A placeholder in the text field when searching for power-ups in the directory.',
          })}
          onKeyUp={onSearchKeyUp}
          className="js-directory-search"
        />
        <a
          href="#"
          className="icon-sm icon-close dark-hover hide js-directory-search-clear"
          onClick={clearSearch}
        />
      </div>
      <div className="directory-navigation-section">
        <ul>
          <li>
            <a
              href={`${getBoardUrlFromShortLink(
                shortLink,
                shortName,
              )}/power-ups`}
              className={cx('directory-navigation-option', {
                active: !section && !category && !powerUpId,
              })}
            >
              <span className="icon-md icon-star" />
              {intl.formatMessage({
                id: 'templates.directory.featured',
                defaultMessage: 'Featured',
                description: 'A link to the featured power-ups section.',
              })}
            </a>
          </li>
          <li>
            <a
              href={`${getBoardUrlFromShortLink(
                shortLink,
                shortName,
              )}/power-ups/enabled`}
              className={cx('directory-navigation-option enable-option', {
                active: section === 'enabled',
              })}
              data-testid={PowerUpTestIds.EnabledPowerUpsLink}
            >
              <span className="icon-md icon-power-up" />
              {intl.formatMessage({
                id: 'templates.directory.enabled',
                defaultMessage: 'Enabled',
                description: 'A link to the enabled power-ups section.',
              })}
              <span className="directory-navigation-power-up-count">
                {enabledCount}
              </span>
            </a>
          </li>
          {showCustomCategory && (
            <li>
              <a
                href={`${getBoardUrlFromShortLink(
                  shortLink,
                  shortName,
                )}/power-ups/custom`}
                className={cx('directory-navigation-option', {
                  active: section === 'custom',
                })}
              >
                <span className="icon-md icon-gear" />
                {intl.formatMessage({
                  id: 'templates.directory.custom',
                  defaultMessage: 'Custom',
                  description: 'A link to the custom power-ups section.',
                })}
              </a>
            </li>
          )}
          <li>
            <a
              href={`${getBoardUrlFromShortLink(
                shortLink,
                shortName,
              )}/power-ups/made-by-trello`}
              className={cx('directory-navigation-option trello-option', {
                active: section === 'made-by-trello',
              })}
              data-testid={PowerUpTestIds.TrelloPowerUpsLink}
            >
              <span className="icon-md icon-board" />
              {intl.formatMessage({
                id: 'templates.directory.made-by-trello',
                defaultMessage: 'Made by Trello',
                description: 'A link to the power-ups that are made by Trello.',
              })}
            </a>
          </li>
        </ul>
      </div>
      <div className="directory-navigation-section">
        <h4 className="directory-navigation-section-header-title">
          {intl.formatMessage({
            id: 'templates.directory.categories',
            defaultMessage: 'Categories',
            description:
              'A heading for a list of categories in the Power-Up directory.',
          })}
        </h4>
        <ul>
          {categories.map((categoryKey) => (
            <li key={categoryKey}>
              <a
                href={`${getBoardUrlFromShortLink(
                  shortLink,
                  shortName,
                )}/power-ups/category/${categoryKey}`}
                className={cx('directory-navigation-option category-link', {
                  active: category === categoryKey,
                })}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  // eslint-disable-next-line formatjs/enforce-default-message, formatjs/enforce-description
                  __html: intl.formatMessage({
                    id: `templates.directory.${categoryKey}`,
                  }),
                }}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

interface DirectorySidebarView {
  directoryView: DirectoryView;
}

class DirectorySidebarView extends View<Board> {
  className() {
    return 'directory-sidebar js-directory-sidebar';
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ directoryView }: any) {
    this.directoryView = directoryView;
    super.initialize(...arguments);

    this.onSearchKeyUp = _.debounce(this.onSearchKeyUp, 100);

    this.listenTo(this.model, { 'change:powerUps': this.render });
    this.listenTo(this.model.boardPluginList, {
      'add remove reset': this.render,
    });
    return this.subscribe(pluginsChangedSignal(this.model), () =>
      this.render(),
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateSearch = (search: any) => {
    this.directoryView.updateSearch(search);

    const clearButton = $('.js-directory-search-clear', this.$el);
    if (search?.length) {
      clearButton.removeClass('hide');
    } else {
      clearButton.addClass('hide');
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSearchKeyUp = (e: any) => {
    let search = e.target.value;
    const key = getKey(e);

    if (key === Key.Escape) {
      search = null;
      this.emptySearchField();
    }

    // Close the responsive sidebar on Enter
    if (key === Key.Enter && this.$el.hasClass('active')) {
      toggleNavigationMenu();
    }

    // Make sure the value has changed.
    if (search !== this.directoryView.search) {
      return this.updateSearch(search);
    }
  };

  emptySearchField = () => {
    return $('.js-directory-search', this.$el).val('');
  };

  clearSearch = () => {
    this.emptySearchField();
    return this.updateSearch(null);
  };

  render() {
    const { isLoading } = this.directoryView;

    ReactDOM.render(
      <div>
        <ReactRootComponent>
          {isLoading ? (
            <DirectorySidebarPlaceholder />
          ) : (
            <DirectorySidebar
              board={this.model}
              showCustomCategory={
                !_.isEmpty(this.directoryView.getCustomPlugins())
              }
              clearSearch={this.clearSearch}
              onSearchKeyUp={this.onSearchKeyUp}
            />
          )}
        </ReactRootComponent>
      </div>,
      this.el,
    );

    return this;
  }
}

export { DirectorySidebarView };
